import React, {Component} from 'react'
import qr from '../../img/qr-code.png'
import mockup from '../../img/mockup.png'
import appStore from '../../img/icons/appStore.png'
import googlePlay from '../../img/icons/google-play-badge.png'
import strings from '../../strings/localeStrings'

export default class AplikacjaMobilna extends Component {

    render() {
        return (
            <div className="aplikacjaMobilna">
                <div className="row mobilkaFixRow">
                    <div className="col-lg-3"></div>
                    <div className="col-lg-3 text-left paddingLeftRight50" style={{paddingTop: 75, paddingBottom: 25}}>
                        <h2 style={{fontWeight: 'bold'}}>{strings.biletyPodReka}</h2>
                        <p>Pobierz naszą aplikację mobilną i miej swoje bilety zawsze przy sobie!
                            Aplikacja umożliwia sprawne korzystanie z wszystkich funkcji naszego systemu. Aby zainstalować aplikację na swoim urządzeniu z systemem Android należy pobrać ją ze sklepu Google Play.</p>
                        <div className="row">
                            <div className="col-sm-6">
                                <p>
                                    <img src={qr} className="img-fluid"/>
                                </p>
                            </div>
                            <div className="col-sm-6">
                                <p>
                                    <a href='https://play.google.com/store/apps/details?id=com.react_marcel&hl=pl&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'><img style={{width: 200}}alt='pobierz z Google Play' src={googlePlay}/></a>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3" style={{minHeight: 470}}>
                        <img src={mockup} className="mobilnaMockup"
                             style={{bottom: 0, left: '15px', position: 'absolute'}}/>
                    </div>
                </div>

            </div>
        )
    }

}



// WEBPACK FOOTER //
// ./src/components/home/homeComponents/AplikacjaMobilna.js